import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

const GROCERY_IMG = "/assets/compare-grocery.jpg";
const FARM_IMG = "/assets/compare-farm.jpg";

export const MeatCompareSlider = () => {
  const [pos, setPos] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const setFromClientX = useCallback((clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, pct)));
  }, []);

  const onPointerDown = (e) => { dragging.current = true; setFromClientX(e.clientX); };
  const onPointerMove = (e) => { if (dragging.current) setFromClientX(e.clientX); };
  const stop = () => { dragging.current = false; };

  return (
    <div
      ref={containerRef}
      className="relative w-full aspect-[16/10] overflow-hidden rounded-3xl select-none cursor-ew-resize ring-1 ring-black/5 shadow-[0_30px_60px_-30px_rgba(26,67,49,0.45)]"
      data-testid="meat-compare-slider"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stop}
      onPointerLeave={stop}
    >
      {/* Base layer — The Farm To You */}
      <img src={FARM_IMG} alt="The Farm To You fresh cuts" draggable={false} className="absolute inset-0 w-full h-full object-cover pointer-events-none"/>
      <span className="absolute bottom-4 right-4 z-20 bg-[var(--ff-primary)] text-white text-[11px] sm:text-xs font-semibold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-lg pointer-events-none">
        The Farm To You
      </span>

      {/* Top layer — Grocery store, clipped to the left of the handle */}
      <div className="absolute inset-0 pointer-events-none" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={GROCERY_IMG} alt="Grocery store meat" draggable={false} className="absolute inset-0 w-full h-full object-cover"/>
        <div className="absolute inset-0 bg-black/10"/>
        <span className="absolute bottom-4 left-4 bg-white/90 text-[var(--ff-text-primary)] text-[11px] sm:text-xs font-semibold uppercase tracking-wider px-3 py-1.5 rounded-full shadow">
          Grocery store
        </span>
      </div>

      {/* Handle */}
      <div className="absolute top-0 bottom-0 z-10 pointer-events-none" style={{ left: `${pos}%`, transform: "translateX(-50%)" }}>
        <div className="w-0.5 h-full bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.15)]"/>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow-lg flex items-center justify-center text-[var(--ff-primary)]">
          <MoveHorizontal size={20}/>
        </div>
      </div>
    </div>
  );
};

export default MeatCompareSlider;
